const dogBreeds = [
  "Affenpinscher",
  "Afghanischer Windhund",
  "Airedale Terrier",
  "Akita Inu",
  "Alaskan Malamute",
  "American Hairless Terrier",
  "American Staffordshire Terrier",
  "American Toy Terrier",
  "Amerikanischer Cocker Spaniel",
  "Appenzeller Sennenhund",
  "Australian Cattle Dog",
  "Australian Kelpie",
  "Australian Shepherd",
  "Australian Silky Terrier",
  "Australian Terrier",
  "Barsoi",
  "Basenji",
  "Basset bleu de Gascogne",
  "Basset fauve de Bretagne",
  "Basset Hound",
  "Bayerischer Gebirgsschweißhund",
  "Beagle",
  "Bearded Collie",
  "Bedlington Terrier",
  "Belgischer Schäferhund",
  "Bergamasker Hirtenhund",
  "Berner Sennenhund",
  "Bernhardiner",
  "Bichon á poil Frisé",
  "Bloodhound",
  "Bologneser",
  "Bolonka Zwetna",
  "Bordeauxdogge",
  "Border Collie",
  "Border Terrier",
  "Boston Terrier",
  "Bouvier Des Flandres",
  "Briard",
  "Bull Terrier",
  "Bullmastiff",
  "Cairn Terrier",
  "Cane Corso Italiano",
  "Cao de agua Portugues",
  "Cao Fila de Sao Miguel",
  "Cavalier King Charles Spaniel",
  "Chesapeake Bay Retriver",
  "Chihuahua",
  "Chinesischer Schopfhund",
  "Chow Chow",
  "Clumber Spaniel",
  "Cockapoo",
  "Collie",
  "Coton de Tuléar",
  "Curly Coated Retriever",
  "Dackel",
  "Dalmatiner",
  "Dandie Dinmont Terrier",
  "Deutsch Drahthaar",
  "Deutsch Kurzhaar",
  "Deutsche Dogge",
  "Deutscher Boxer",
  "Deutscher Jagdterrier",
  "Deutscher Schäferhund",
  "Dobermann",
  "Dogo Argentino",
  "Dogo Canario",
  "Drahthaar-Foxterrier",
  "Drever",
  "Elo",
  "Englische Bulldogge",
  "Englischer Setter",
  "Englischer Springer Spaniel",
  "English Cocker Spaniel",
  "English Toy Terrier",
  "Epagneul Breton",
  "Eurasier",
  "Field Spaniel",
  "Finnischer Spitz",
  "Flat Coated Retriever",
  "Foxhound",
  "Foxterrier",
  "Französische Bulldogge",
  "Golden Retriever",
  "Goldendoodle",
  "Gordon Setter",
  "Griffon Bruxellois",
  "Großer Münsterländer",
  "Großer Schweizer Sennenhund",
  "Havaneser",
  "Hovawart",
  "Irish Red Setter",
  "Irish Terrier",
  "Irish Water Spaniel",
  "Irish Wolfhound",
  "Italienisches Windspiel",
  "Jack Russel Terrier",
  "Japan Chin",
  "Japan Spitz",
  "Japanischer Akita",
  "Japanischer Terrier",
  "Kaninchendackel",
  "Keeshond",
  "Kleiner Münsterlander",
  "Komondor",
  "Kooikerhondje",
  "Kroatischer Schäferhund",
  "Kromfohrländer",
  "Kyi Leo",
  "Labrador Retriever",
  "Lagotto Romagnolo",
  "Lakeland Terrier",
  "Lancashire Heeler",
  "Leonberger",
  "Lhasa Apso",
  "Löwchen",
  "Malinois",
  "Malteser",
  "Manchester Terrier",
  "Maremmen Abruzzen Schäferhund",
  "Mastiff",
  "Miniature American Shepherd",
  "Miniature Bull Terrier",
  "Mittelschnauzer",
  "Mops",
  "Neufundländer",
  "Norfolk Terrier",
  "Norwegischer Elchhund",
  "Norwegischer Lundehund",
  "Norwich Terrier",
  "Old English Sheepdog",
  "Olde English Bulldogge",
  "Papillon",
  "Parson Russell Terrier",
  "Patterdale Terrrier",
  "Pekinese",
  "Petit Basset griffon vendéen",
  "Pharaonenhund",
  "Podenco Canario",
  "Pointer",
  "Prager Rattler",
  "Pudel",
  "Puli",
  "Pyrenäen-Berghund",
  "Rat Terrier",
  "Rhodesian Ridgeback",
  "Riesenschnauzer",
  "Rottweiler",
  "Saluki",
  "Samojede",
  "Schapendoes",
  "Schipperke",
  "Schottischer Jagdhund",
  "Schwarzer Terrier",
  "Scottish Terrier",
  "Sealyham Terrier",
  "Shar Pei",
  "Shetland Sheepdog",
  "Shiba Inu",
  "Shih Tzu",
  "Siberian Husky",
  "Skye Terrier",
  "Soft Coated Wheaten Terrier",
  "Staffordshire Bull Terrier",
  "Sussex Spaniel",
  "Tibet Terrier",
  "Tibet-Spaniel",
  "Toy Bulldog",
  "Toy Pudel",
  "Tschechischer Terrier",
  "Ungarischer Vizsla",
  "Volpino Italiano",
  "Weimaraner",
  "Weißer Schäferhund",
  "Welsh Corgi Cardigan",
  "Welsh Corgi Pembroke",
  "Welsh Springer Spaniel",
  "Welsh Terrier",
  "West Highland White Terrier",
  "Westgotenspitz",
  "Whippet",
  "Windhund",
  "Yorkshire Terrier",
  "Zwergdackel",
  "Zwergpinscher",
  "Zwergpudel",
  "Zwergschnauzer",
  "Zwergspitz",
];
